module.exports = __webpack_public_path__ + "img/leonor.37f47e5d.jpg";